import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './context/AuthContext'
import LoginPage from './pages/LoginPage'
import Dashboard from './pages/Dashboard'
import AccountsPage from './pages/AccountsPage'
import MovementsPage from './pages/MovementsPage'
import TransferPage from './pages/TransferPage'
import CVUPage from './pages/CVUPage'
import BajaCVUPage from './pages/BajaCVUPage'
import CVUInfoPage from './pages/CVUInfoPage'
import ClientsPage from './pages/ClientsPage'
import EstadoPage from './pages/EstadoPage'
import UsuariosPage from './pages/UsuariosPage'
import MisCVUsPage from './pages/MisCVUsPage'
import AwsDashboardPage from './pages/AwsDashboardPage'
import LiquidacionesPage from './pages/LiquidacionesPage'
import MovementsxPage from './pages/MovementsxPage'
import ConsolidacionPage from './pages/ConsolidacionPage'
import SaldoHistoricoPage from './pages/SaldoHistoricoPage'
import BindUsuariosPage from './pages/BindUsuariosPage'
import CoelsaConsultPage from './pages/CoelsaConsultPage'
import AuditoriaPage from './pages/AuditoriaPage'
import SeguridadPage from './pages/SeguridadPage'
import ChilePage from './pages/ChilePage'
import BankNotifications from './components/BankNotifications'
import './App.css'

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth()

  if (loading) {
    return <div className="loading-container">
      <div className="spinner"></div>
      <p>Cargando...</p>
    </div>
  }

  return isAuthenticated ? children : <Navigate to="/login" replace />
}

function App() {
  return (
    <>
      {/* Notificaciones bancarias en tiempo real (solo CREDENCIAL) */}
      <BankNotifications />
      
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/aws" element={
          <ProtectedRoute>
            <AwsDashboardPage />
          </ProtectedRoute>
        } />
        <Route path="/" element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }>
          <Route index element={<Navigate to={localStorage.getItem('flash_market') === 'CL' ? '/clp' : '/accounts'} replace />} />
          <Route path="accounts" element={<AccountsPage />} />
          <Route path="cvu-info" element={<CVUInfoPage />} />
          <Route path="movements" element={<MovementsPage />} />
          <Route path="movementsx" element={<MovementsxPage />} />
          <Route path="transfer" element={<TransferPage />} />
          <Route path="consolidacion" element={<ConsolidacionPage />} />
          <Route path="cvu" element={<CVUPage />} />
          <Route path="baja-cvu" element={<BajaCVUPage />} />
          <Route path="clients" element={<ClientsPage />} />
          <Route path="estado" element={<EstadoPage />} />
          {/* Nuevas rutas para sistema de usuarios del portal */}
          <Route path="usuarios" element={<UsuariosPage />} />
          <Route path="mis-cvus" element={<MisCVUsPage />} />
          <Route path="liquidaciones" element={<LiquidacionesPage />} />
          <Route path="saldo-historico" element={<SaldoHistoricoPage />} />
          <Route path="bind-usuarios" element={<BindUsuariosPage />} />
          <Route path="consulta-coelsa" element={<CoelsaConsultPage />} />
          <Route path="auditoria" element={<AuditoriaPage />} />
          <Route path="seguridad" element={<SeguridadPage />} />
          <Route path="chile" element={<Navigate to="/clp" replace />} />
          <Route path="clp" element={<ChilePage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  )
}

export default App
